/* eslint-disable @typescript-eslint/no-explicit-any */
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      maxHeight: 'inherit',
    },
    resourcesWrapper: {
      flex: 1,
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    resourcesItem: {
      marginLeft: '0',
      marginRight: '0',
      marginBottom: theme.spacing(1),
      padding: '8px',
      borderRadius: theme.spacing(1),
      backgroundColor: '#ffffff',
    },
    content: {
      width: '560px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    tabContent: {
      minHeight: '400px',
      [theme.breakpoints.down('sm')]: {
        minHeight: 0,
      },
    },
    footer: {
      display: 'flex',
      marginTop: 0,
      paddingBottom: '14px',
      paddingLeft: '6px',
      paddingRight: '6px',
    },
    titleView: {
      borderTopLeftRadius: '4px',
      borderTopRightRadius: '4px',
      marginBottom: '16px',
      height: '100%',
      backgroundColor: 'white',
    },
    grayBox: {
      marginBottom: '0',
      padding: '0px',
      paddingTop: '8px',
      marginLeft: 0,
      marginRight: 0,
      paddingBottom: '8px',
      backgroundColor: '#ffffff',
      minHeight: '42px',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderRadius: '8px',
      '& .MuiBox-root': {
        display: 'flex',
        color: theme.palette.grey[800],
      },
    },
    stackView: {
      backgroundColor: theme.palette.grey[50],
    },
    sectionItem: {
      '& .MuiBox-root': {
        backgroundColor: theme.palette.grey[100],
        fontSize: '11px',
        fontWeight: 600,
        color: theme.palette.grey[700],
      },
    },
    personnelItem: {
      fontSize: '13px',
      color: theme.palette.grey[900],
      '& .MuiCheckbox-root': {
        marginRight: theme.spacing(1),
        padding: 0,
        paddingLeft: theme.spacing(1),
      },
      '& .MuiBox-root': {
        display: 'flex',
        alignItems: 'center',
        height: '28px',
      },
      '& .MuiBox-root:not(:first-child)': {
        flex: '0 1 20%',
        justifyContent: 'center',
        fontWeight: 600,
      },
      '& .MuiBox-root:first-child': {
        flex: '0 1 100%',
      },
    },
    dropDownContainer: {
      display: 'flex',
      height: '0px',
      overflow: 'hidden',
    },
    countyItem: {
      fontSize: '14px',
      color: theme.palette.grey[700],
      fontWeight: 700,
    },
    contentStackView: {
      backgroundColor: '#fefefe',
      border: '0',
      marginBottom: '14px',
      marginRight: '2px',
      borderRadius: '12px',
      paddingTop: '12px',
      paddingLeft: '16px',
      paddingRight: '16px',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '8px',
        paddingRight: '8px',
        marginRight: 0,
      },
    },
    contactGrid: {
      padding: '0px 0px 0px 0px !important',
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        justifyContent: 'flex-end',
      },
    },
    detailsText: {
      paddingTop: '10px',
      fontWeight: 400,
      fontSize: '14px',
      color: '#5d5d5f',
      whiteSpace: 'normal'
    },
  };
});

const TabsStyles = (): any => ({
  root: {},
  indicator: {
    backgroundColor: 'transparent',
  },
});

const TabItemStyles = (theme: Theme): any => ({
  root: {
    opacity: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 0,
    paddingRight: theme.spacing(2),
    backgroundColor: 'transparent',
    textTransform: 'none',
  },
  selected: {
    backgroundColor: theme.palette.grey[100],
  },
});

export { TabsStyles, TabItemStyles };

export default useStyles;
